import ProjectCard from './ProjectCard';

const Projects = () => {
  return (
    <section id="projects" className="bg-[#edf2fc] dark:bg-light-black py-28">
      <div className="max-w-screen-xl mx-auto px-2">
        <h3
          className="section-title relative text-4xl font-black  text-black dark:text-white underline underline-offset-[8px] decoration-orange pb-8"
          style={{ fontFamily: " 'Dancing Script', cursive" }}
        >
          Projects
        </h3>
        {/* Card  */}
        <div className="mb-10">
          <ProjectCard />
        </div>
        <div className="flex justify-center">
          <a
            className="py-[10px] px-[18px] bg-black text-white rounded inline-block my-8 hover:bg-orange transform translate duration-700 dark:bg-white dark:text-black dark:hover:bg-orange dark:hover:text-white font-medium"
            href="https://github.com/mohammadliazul"
            target="_blank"
            rel="noopener noreferrer"
          >
            Visit my GitHub
          </a>
        </div>
      </div>
    </section>
  );
};

export default Projects;
